var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("span", [_vm._v(_vm._s(_vm.datetime))]),
      _vm.errorSign
        ? _c(
            "el-tooltip",
            {
              staticClass: "right",
              attrs: { effect: "dark", content: _vm.message, placement: "top" },
            },
            [
              _c("div", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }